import { type FormEvent, useState } from 'react';
import { normalizeTagId } from '@notlost/shared';
import { Page } from '../components/Layout';
import { navigate } from '../lib/router';
import { t } from '../i18n';

/** Fallback for a damaged QR: type the short code printed under it. */
export function CodeEntry() {
  const [value, setValue] = useState('');
  const [invalid, setInvalid] = useState(false);

  function submit(e: FormEvent) {
    e.preventDefault();
    const id = normalizeTagId(value);
    if (!id) {
      setInvalid(true);
      return;
    }
    navigate(`/t/${id}`);
  }

  return (
    <Page minimalHeader>
      <div className="card p-6">
        <h1 className="text-2xl font-semibold tracking-tight">{t('code.title')}</h1>
        <p className="mt-2 text-body">{t('code.body')}</p>
        <form onSubmit={submit} className="mt-6 flex flex-col gap-3">
          <label htmlFor="code" className="text-sm font-semibold">
            {t('code.label')}
          </label>
          <input
            id="code"
            inputMode="text"
            autoCapitalize="characters"
            autoComplete="off"
            autoCorrect="off"
            spellCheck={false}
            maxLength={14}
            value={value}
            onChange={(e) => {
              setValue(e.target.value.toUpperCase());
              setInvalid(false);
            }}
            placeholder="ABCDE-12345"
            aria-invalid={invalid}
            className="field min-h-14 text-center text-2xl font-semibold tracking-[0.18em]"
          />
          {invalid && (
            <p role="alert" className="text-sm font-semibold text-danger">
              {t('code.invalid')}
            </p>
          )}
          <button type="submit" className="btn btn-primary min-h-14 text-lg">
            {t('code.submit')}
          </button>
        </form>
      </div>
    </Page>
  );
}
